import EventListWidget from './components/EventList/widget.svelte';

var div = document.getElementById('cobraticket-event-list');
let embed;
if (div) {
	var script = document.currentScript;
	var attributes: any = {};
	if (script) {
		script.parentNode?.appendChild(script);
		for (var i = 0; i < script.attributes.length; i++) {
			var attr = script.attributes[i];
			attributes[attr.name] = attr.value;
		}
	}
	console.log(attributes);
	embed = new EventListWidget({
		target: div,
		props: {
			publicKey: attributes['public-key'],
			primaryColor: attributes['primary-color'],
			secondaryColor: attributes['secondary-color'],
			darkMode: attributes['dark-mode'] == 'true' ? true : false,
			eventUrl: attributes['event-url']
		}
	});
}
export default embed;
